const getDefaultListBase = () => {
  if (typeof window === 'undefined') {
    return 'https://bescswap.com'
  }
  const { hostname, port } = window.location
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    const localPort = port || '3000'
    return `http://${hostname}:${localPort}`
  }
  return window.location.origin
}

const DEFAULT_LIST_BASE = getDefaultListBase()

const PANMONEY_EXTENDED = `${DEFAULT_LIST_BASE}/tokenlists/pancake-default.tokenlist.json`

const PANMONEY_TOP100 = `${DEFAULT_LIST_BASE}/tokenlists/pancake-default.tokenlist.json`

export const UNSUPPORTED_LIST_URLS: string[] = []

// lower index == higher priority for token import
export const DEFAULT_LIST_OF_LISTS: string[] = [
  PANMONEY_TOP100,
  PANMONEY_EXTENDED,
  ...UNSUPPORTED_LIST_URLS, // need to load unsupported tokens as well
]

// default lists to be 'active' aka searched across
export const DEFAULT_ACTIVE_LIST_URLS: string[] = []
